import React, {Component} from 'react';
import { Row, Col } from 'react-bootstrap';
//import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';

import Header from '../decoration/header';
import SendMessageForm from './sendMessageForm';
import Footer from '../footer/footer';
import './contactUs.css'
import map from '../decoration/img/bnmmap.png';

class ContactUs extends Component {
	render() {
		return (
			<div >
				<Header/>
                <div id='banner'>CONTACT US</div>
				<div id="contactUsContent">
				    <div id="contactUsCol">
							<SendMessageForm/>
				    </div>
				    <div id="contactUsCol2">
								<h4><b>ADDRESS</b></h4>
								<br/>
								<div>Unit B, G/F, E Wah Factory Building</div>
								<div>56-60 Wong Chuk Hang Road</div>	
								<div>Hong Kong</div>
								<br/>
								<div><span>Email:</span>Info@bnm.hk</div>
								<div><span>Tel:</span>+852 2854 2834</div>
								<div><span>Whatsapp:</span>+852 9164 2834</div>
								<div><span>Fax:</span>+852 2854 2844</div>
				      	<br/>

								<h4><b>OPENING HOURS</b></h4>
			          <br/>
			          <div>Monday to Saturday</div>
			          <div>9:00 AM - 6:00 PM</div>
			          <div>Closed on Sunday and Public Hoildays</div>
			          <br/>
			          <div>(Deliveries are available everyday including public hoildays,</div>
                      <div>orders have to be confirmed within shop opening hours.)</div>
				      <br/>
						<h4><b>MAP</b></h4>
						<img alt="location map" id='map' src={map}></img>
			          <br/>
				    </div>
				</div>
				<Footer/>
		  </div>
		)
	}
}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/components/contactUs/contactUs.js